import auth0 from 'auth0-js'
import Vue from 'vue'
import EventEmitter from 'event-emitter'
import router from './../router'
import Resource from 'vue-resource'

Vue.use(Resource)

export default class AuthService {

  authenticated = this.isAuthenticated()
  authNotifier = new EventEmitter()

  constructor () {
    this.login = this.login.bind(this)
    this.setSession = this.setSession.bind(this)
    this.logout = this.logout.bind(this)
    this.isAuthenticated = this.isAuthenticated.bind(this)
  }

  auth0 = new auth0.WebAuth({
    domain: 'gweit.eu.auth0.com',
    clientID: '1arTRlw6K1AINYliP54281pQxemtLRwX',
    redirectUri: 'http://localhost:8080/callback',
    // redirectUri: 'http://vue.drophost.it/callback',
    audience: 'https://gweit.eu.auth0.com/userinfo',
    responseType: 'token id_token',
    scope: 'openid profile email'
  })

  login () {
    this.auth0.authorize()
  }

  handleAuthentication (id, jwt) {
    console.log(id)
    console.log(jwt)
    localStorage.setItem('userid', id)
    localStorage.setItem('jwt', jwt)
    // this.auth.authenticated = true
    // router.replace('ombrelli')
    // Vue.http
    //         .post('http://localhost:44534/ombrelloni', {'userid': id}).then((data) => {
    //           console.log(data)
    //           // router.replace('ombrelli/' + id)
    //         }, (error) => {
    //           console.log(error)
    //         })
    Vue.http
            .get('http://localhost:44537/ombrelloni',
      {
        headers: {
          'Authorization': 'Bearer ' + jwt
        }
      },
              ).then((data) => {
                console.log(data.body.hotels.length)
                if (data.body.hotels.length > 1) {
                  console.log('multihotel')
                  router.replace('hotel')
                } else if ((data.body.hotels.length === 1)) {
                  console.log('one hotel')
                  router.replace('ombrelli/' + data.body.hotels[0]._id)
                } else {
                  console.log('no hotel')
                  router.replace('addhotel')
                }
              }, (error) => {
                console.log(error)
              })
    // this.auth0.parseHash((err, authResult) => {
    //   console.log(authResult)
    //   // if (authResult && authResult.accessToken && authResult.idToken) {
    //   //   this.setSession(authResult)
    //   //   // router.replace('hello')
    //   // }
    //   if (authResult) {
    //     // this.setSession(authResult)
    //     console.log(authResult)
    //     // router.replace('hello')
    //   } else if (err) {
    //     router.replace('hello')
    //     console.log(err)
    //     alert(`Error: ${err.error}. Check the console for further details.`)
    //   }
    //   // get user profile data
    //   this.auth0.client.userInfo(authResult.accessToken, function (err, profile) {
    //     if (err) {
    //       // handle error
    //       alert(err)
    //     }
    //     console.log(profile.email)
    //     localStorage.setItem('profile', JSON.stringify(profile))
    //     localStorage.setItem('email', profile.email)
    //   })
    //   Vue.$http
    //     .post('https://gweit.eu.auth0.com/oauth/token', {client_id: 'Kypu4g8sp1yYw8f9CWlyAFH4oXO9RWhT', client_secret: 'j9I5NW9PqVDPXj0af0mVSrpKligpdkjBkxK1qjpPeAUZ78lsC7_enQT7FdzwBZAI', audience: 'https://obrelleria.node.systems', grant_type: 'client_credentials'}).then((data) => {
    //       console.log(data)
    //       const access = JSON.parse(data.bodyText)
    //       console.log(access.access_token)
    //       localStorage.setItem('token', access.access_token)
    //     }, (error) => {
    //       console.log(error)
    //     })
    //   // Vue.$http
    //   //   .post('http://localhost:8000/api/user', {'email': localStorage.email}).then((data) => {
    //   //     console.log(data)
    //   //     // const access = JSON.parse(data.bodyText)
    //   //     // console.log(access.access_token)
    //   //     // localStorage.setItem('token', access.access_token)
    //   //   }, (error) => {
    //   //     console.log(error)
    //   //   })
    // })
  }

  setSession (authResult) {
    // Set the time that the access token will expire at
    let expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    )
    localStorage.setItem('access_token', authResult.accessToken)
    localStorage.setItem('id_token', authResult.idToken)
    localStorage.setItem('expires_at', expiresAt)
    this.authNotifier.emit('authChange', { authenticated: true })
  }

  logout () {
    // Clear access token and ID token from local storage
    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('expires_at')
    localStorage.removeItem('token')
    localStorage.removeItem('profile')
    localStorage.removeItem('jwt')
    localStorage.removeItem('userid')
    localStorage.removeItem('email')
    localStorage.removeItem('profile.email')
    this.userProfile = null
    this.authNotifier.emit('authChange', false)
    // navigate to the home route
    router.replace('/')
  }

  isAuthenticated () {
    // Check whether the current time is past the
    // access token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem('expires_at'))
    return new Date().getTime() < expiresAt
  }
}



// WEBPACK FOOTER //
// ./src/auth/AuthService.js